import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Login from "./Login";

const AdminProtectedRoute = () => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("adminAuthenticated") === "true"
  );

  // Check authentication on mount and location change
  useEffect(() => {
    const checkAuth = () => {
      setIsAuthenticated(localStorage.getItem("adminAuthenticated") === "true");
    };

    // Check auth on mount and location change
    checkAuth();

    // Listen for storage events (when localStorage changes in other tabs/windows)
    window.addEventListener("storage", checkAuth);

    // Listen for custom event (when localStorage changes in same tab)
    window.addEventListener("adminAuthChange", checkAuth);

    return () => {
      window.removeEventListener("storage", checkAuth);
      window.removeEventListener("adminAuthChange", checkAuth);
    };
  }, [location.pathname]); // Re-check when route changes

  // If not authenticated, show login page
  if (!isAuthenticated) {
    return <Login />;
  }

  // If authenticated, render the protected content (AdminLayout with Outlet)
  return <Outlet />;
};

export default AdminProtectedRoute;

